var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"loader"},[_c('section',{staticClass:"loader__container"},[_c('FuseaccessLogo')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }